(function () {
    'use strict';
    /* login module */
    angular.module('uwAgenda.login', [
        'uwAgenda.global'

    ])
    .config(LoginConfig);

    LoginConfig.$inject = ['$stateProvider'];
    function LoginConfig($stateProvider) {
        $stateProvider
            .state('Login', {
                url: '/auth',
                templateUrl: '/app/login/templates/login.template.html',
                data: {
                    requiresLogin: false
                },
                params: {
                    username: null,
                    password: null
                },
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {

                    languages: ['AdministrationService', function (AdministrationService) {
                        return AdministrationService.languages();
                    }],
                    modals: ['$uibModalStack', function ($uibModalStack) {
                        // close all open modals 
                        $uibModalStack.dismissAll();
                        return true;
                    }],
                    deps: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load({
                            name: 'uwAgenda Login',
                            insertBefore: '#ng_load_plugins_before',
                            serie: true,
                            files: [
                                '/assets/lib/lazy-loaded/login-4.min.css',
                                '/assets/lib/lazy-loaded/jquery.validate.min.js',
                                '/assets/lib/lazy-loaded/additional-methods.min.js',
                                '/assets/lib/lazy-loaded/jquery.backstretch.min.js'
                            ]
                        });
                    }]
                }
            })
            .state('Registration', {
                url: '/registration',
                templateUrl: '/app/login/templates/registration.template.html',
                data: {
                    requiresLogin: false
                },
                controller: 'RegistrationController',
                controllerAs: 'vm',
                resolve: {
                    licences: ['LicenceService', function (LicenceService) {
                        return LicenceService.queryLicence();
                    }],

                    countries: ['AdministrationService', function (AdministrationService) {
                        return AdministrationService.countries();
                    }],

                    contactinfotypes: ['AdministrationService', function (AdministrationService) {
                        return AdministrationService.contactinfotypes();
                    }]
                }
            })
            .state('ForgotPassword', {
                url: '/forgot',
                templateUrl: '/app/login/templates/forgot-password.template.html',
                data: {
                    requiresLogin: false
                },
                controller: 'ForgotPasswordController',
                controllerAs: 'vm'
            })
            .state('ResetPassword', {
                url: '/reset?key&id&lid',
                templateUrl: '/app/login/templates/reset-password.html',
                data: {
                    requiresLogin: false
                },
                controller: 'ResetPasswordController',
                controllerAs: 'vm'
            })
            .state('LinkCorilusPassport', {
                url: '/link-corilus-passport',
                templateUrl: '/app/login/templates/link-corilus-passport.html',
                data: {
                    requiresLogin: false
                },
                controller: 'LinkCorilusPassportController',
                controllerAs: 'vm'
            });
    } // config

})();